var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card-img-art"},[_c('img',{attrs:{"src":_vm.url('/media/prodotti-gruppi/' + _vm.filename),"alt":_vm.filename}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cod_articolo))])])])}
var staticRenderFns = []

export { render, staticRenderFns }